export default "__VITE_ASSET__5c7bbb04__"